const index = () => import(/* webpackChunkName: "herb" */ './Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/china/v2020/index',
      name: 'china_v2020_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/v2020/router.js